import PropTypes from 'prop-types';
import React from 'react';

import EditorialCard from '../../Community/EditorialCard/EditorialCard';
import CardTitle from '../../Elements/CardTitle/CardTitle';

import './ResourceList.scss';

export default class ResourceList extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        /**
         * string title heading of section
         */
        title: PropTypes.string,
        /**
         * array of resources
         */
        resources: PropTypes.arrayOf(
            PropTypes.shape({
                /**
                 * string title
                 */
                title: PropTypes.string.isRequired,
                /**
                 * object of image with src and alt
                 */
                image: PropTypes.shape({
                    src: PropTypes.string,
                    alt: PropTypes.string,
                }).isRequired,
                /**
                 * string url
                 */
                url: PropTypes.string.isRequired,
            })
        ),
        /**
         * boolean for showing description or not
         */
        shouldRenderDescription: PropTypes.bool,
    };

    static defaultProps = {
        title: 'Related Resources',
        shouldRenderDescription: false,
    };

    renderResourceItem = ({ title, description, image, url }, index) => {
        return (
            <li className="resource-item" key={`resource-${index}`}>
                <EditorialCard
                    contentUrl={url}
                    title={title}
                    description={description}
                    image={image.src}
                    url={url}
                />
            </li>
        );
    };

    render() {
        return (
            <div className="component-Resources-ResourceList">
                <CardTitle headerTag="h1" title="Related Resources" />
                <ul>{this.props.resources.map(this.renderResourceItem)}</ul>
            </div>
        );
    }
}
